import { Card, Text, Button, Loading } from '@sede-enterprise/shell-ds-react-framework'
import React, { useContext } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { UnitContext } from '../../App';
import './Notifications.css'
import { generateDate, mmOrMiles } from '../../util/helperFunctions';
import { DE_INSTALL_HELP, DE_INSTALLED_PROD_UNIT } from '../../util/helperTexts';


import * as R from "rambda";

const Notifications = ({ alerts, loading, markAsRead, closeNotifications }) => {
    console.log("alerts in notifications", alerts);
    console.log("loading in notifications", loading);
    console.log("alertsList in notifications", alerts.alertsList);
    const units = useContext(UnitContext).units;

    return (
        <div className='notifications-container'>
            {loading && <div className='loading-container'><Loading /> </div>}
            {!loading && alerts?.length === 0 && <Text>No New Alerts! </Text>}
            {!loading && alerts?.length > 0 && alerts.map(alert => (
                <Card className='notifications-card' bodyPadding={false} key={alert.id}>
                    <div className='notifications-body'>
                        {(alert.eventCode === "RemnentLife" || alert.eventCode === 'WallThickness')
                            && <div className='type-1-notifications'>
                                <div className='notification-header'>
                                    <Text size='large'>{alert.eventCode}</Text>
                                    <Text size='small' prominence='subtle'>{generateDate(alert.startDate)} to {generateDate(alert.endDate)}</Text>
                                </div>
                                <div className='notification-body'>
                                    <Text type='span'>Sensor : </Text>
                                    <Link
                                        className={
                                            alert.uninstalled
                                                ? "link redContent"
                                                : "link blueContent"
                                        }
                                        to={`/home/${encodeURIComponent(alert.sensor_id)}/details`}
                                        title={
                                            alert.uninstalled
                                                ? R.path(
                                                    ["conditionMonitoringLocationName"],
                                                    alert.conditionMonitoringLocationName
                                                ) === DE_INSTALLED_PROD_UNIT
                                                    ? DE_INSTALL_HELP.bukam
                                                    : DE_INSTALL_HELP.other
                                                : ""
                                        }
                                        onClick={() => closeNotifications()}
                                    >{alert.isRealSensor && alert.sensor_id}
                                        {!alert.sensor.isRealSensor && <span title="This CML has no sensor installed" className="redContent">No Sensor</span>}

                                    </Link>
                                    {Object.hasOwn(alert, "remanentLife") ? <Text>Remnent Life: {alert.remanentLife.toFixed(2)} yrs</Text> : null}
                                </div>
                                <div className='notification-footer'>
                                    <Button variant='outlined' onClick={() => markAsRead(alert.id, 'WT')} size='xsmall'>Mark as Read</Button>
                                </div>
                            </div>
                        }

                        {
                            (alert.eventCode !== "RemnentLife" && alert.eventCode !== 'WallThickness')
                            && <div className='type-2-notifications'>
                                <div className='notification-header'>
                                    <Text size='large'>{alert.category}</Text>
                                    <Text size='small' prominence='subtle'>{generateDate(alert.alertStartDate)} to {generateDate(alert.alertEndDate)}</Text>
                                </div>
                                <div className='notification-body'>
                                    <Text>Corr. Rate : {units ? (0.0393701 * alert?.averageCRValue).toFixed(2) : alert?.averageCRValue?.toFixed(2)} {mmOrMiles(units)}</Text>
                                    <Text type='span'>Sensor : </Text>
                                    <Link
                                        className={
                                            alert.uninstalled
                                                ? "link redContent"
                                                : "link blueContent"
                                        }
                                        to={`/home/${encodeURIComponent(alert.sensor_id)}/details`}
                                        // title={
                                        //     alert.uninstalled
                                        //         ? R.path(
                                        //             ["equipment", "subsystem", "system", "shortName"],
                                        //             alert.conditionMonitoringLocationName
                                        //         ) === DE_INSTALLED_PROD_UNIT
                                        //             ? DE_INSTALL_HELP.bukam
                                        //             : DE_INSTALL_HELP.other
                                        //         : ""
                                        // }
                                        onClick={() => closeNotifications()}
                                    >
                                        {alert.isRealSensor && alert.sensor_id}
                                        {!alert.isRealSensor && <span title="This CML has no sensor installed" className="redContent">No Sensor</span>}
                                    </Link>
                                </div>
                                <div className='notification-footer'>
                                    <Button variant='outlined' onClick={() => markAsRead(alert.id)} size='xsmall'>Mark as Read</Button>
                                </div>
                            </div>
                        }
                    </div>

                </Card>
            ))}
        </div>
    )
}

export default Notifications